import React from 'react'

import Type from '../Data/Type.json'
import {
	DivCardType,
	CardType,
	CardIconType,
	H3CardType,
} from '../common/Card/CardType'

function Cours() {
	return (
		<>
			{Type.map((content, i) => (
				<DivCardType key={content?.id}>
					<CardType>
						<CardIconType>
							<ion-icon name="arrow-forward-outline"></ion-icon>
						</CardIconType>

						<H3CardType>
							<a href="#planning">{content?.name}</a>
						</H3CardType>
					</CardType>
				</DivCardType>
			))}
		</>
	)
}
export default Cours
